import type { LoaderFunction } from 'react-router-dom';
import { apiGetMostMatchesWrestlerWomanListStats } from "../../components/ui_components/ApiList";

export const MostFightsFemaleResponsiveLoader: LoaderFunction = async ({ request }) => {
    try {
        const url = new URL(request.url);
        const year = url.searchParams.get('year') || 'globale';

        const response = await apiGetMostMatchesWrestlerWomanListStats(1, year, '');
        return response;
    } catch (error) {
        console.error('Loader error:', error);
        throw new Error('Failed to load data');
    }
};
